<template>
  <div>
    <h5>iPASS MONEY付款說明</h5>
    <ul class="has-type-decimal">
      <li>使用 iPASS MONEY 恕不適用分期付款</li>
      <li>iPASS MONEY 接受信用卡付款</li>
      <li>付款額度限制：單筆 5 萬 / 每日限額 10 萬 / 每月限額 30 萬</li>
      <li>詳情請見一卡通官網 > 常見問題</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'IPassMoney',
};
</script>
